import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import withForm from 'modules/common/hoc/withForm';
import * as actions from '../action';
import * as c from '../constant';

function UpdateViolationModal({
  violationData,
  ovrid,
  setFormData,
  formData,
  getSelectedViolation,
  getViolationsMatrixList,
  matrixList,
  createInput,
  updating,
  updateSingleViolation,
  showTransactionTrafficViolator,
}) {
  const setModal = useContext(ModalContext);
  const onSetFormData = () => {
    if (!_.isEmpty(violationData)) {
      const args = {
        ...violationData,
      };

      setFormData(args);
    }
  };

  useEffect(() => {
    getViolationsMatrixList();
  }, []);

  useEffect(() => {
    onSetFormData();
  }, []);

  const handleDropDownChange = (key) => (e) => {
    getSelectedViolation(e.id, ({ data }) => {
      setFormData({
        violation_code: _.get(data, 'attributes.violation_code'),
        particular: _.get(data, 'attributes.particular'),
        reference: _.get(data, 'attributes.reference'),
        amount: _.get(data, 'attributes.fine'),
      });
    });
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const createDropdownMatrix = (list) => {
    const newList = [];

    list.map((data) => {
      newList.push({
        label: `${data.attributes.violation_code} - ${data.attributes.particular}`,
        value: data.attributes.violation_code,
        id: data.id,
      });

      return true;
    });

    return newList;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateSingleViolation(violationData.id, ovrid, formData, () => {
      setModal({ isOpen: false });
      showTransactionTrafficViolator(ovrid);
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="col-12 form-group">
          <label className="form-label">Violation Code:</label>
          <div>
            <Select
              name="reactSelect"
              required
              options={createDropdownMatrix(matrixList)}
              styles={customStyle}
              placeholder="Select Violation Code"
              value={{
                label: _.get(formData, 'violation_code') || '',
                value: _.get(formData, 'violation_code') || '',
              }}
              onChange={handleDropDownChange('violation_code')}
            />
          </div>
        </div>
        <div className="col-12 form-group">
          {createInput(
            { key: 'particular', label: 'Particular:' },
            {
              disabled: true,
            }
          )}
        </div>
        <div className="col-12 form-group">
          {createInput(
            { key: 'reference', label: 'Reference:' },
            {
              disabled: true,
            }
          )}
        </div>
        <div className="col-12 form-group">
          {createInput(
            { key: 'amount', label: 'Fine Amount:' },
            {
              disabled: true,
            }
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateViolationModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  violationData: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getSelectedViolation: PropTypes.instanceOf(Function).isRequired,
  getViolationsMatrixList: PropTypes.instanceOf(Function).isRequired,
  matrixList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateSingleViolation: PropTypes.instanceOf(Function).isRequired,
  ovrid: PropTypes.string.isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_SINGLE_VIOLATIONS) > -1,
  matrixList: _.get(api, `${c.GET_VIOLATION_MATRIX_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateViolationModal);
